import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _StimulusShow;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "jsx-a11y/click-events-have-key-events": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconBankLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import { Text } from '@instructure/ui-text';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
import StimulusShowInfo from '../StimulusShowInfo';
import ActionButtons from '../../../../../building/components/resources/ActionButtons';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import Overlay from '../../../shared/overlay';
export var StimulusShow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_StimulusShow = /*#__PURE__*/function (_Component) {
  function StimulusShow() {
    var _this;
    _classCallCheck(this, StimulusShow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StimulusShow, [].concat(args));
    _defineProperty(_this, "switchOnEditing", function () {
      _this.props.switchOnEditing();
    });
    return _this;
  }
  _inherits(StimulusShow, _Component);
  return _createClass(StimulusShow, [{
    key: "renderBankIcon",
    value: function renderBankIcon() {
      if (this.props.isBankedContent || this.props.quizEntry.isArchivedBankEntry) {
        return jsx(IconBankLine, null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var stimulusLabel = this.props.stimulus.passage ? t('Passage') : t('Stimulus');
      return jsx(Overlay, {
        onClick: this.switchOnEditing,
        wrapperStyles: this.props.styles.stimulusWrapper,
        tabIndex: "-1",
        hideOverlay: this.props.isQuizContentLocked
      }, jsx("div", {
        css: this.props.styles.stimulus
      }, jsx("div", {
        css: this.props.styles.header
      }, jsx("div", {
        css: this.props.styles.leftHeader
      }, this.renderBankIcon(), jsx(Flex, {
        margin: "0 x-small"
      }, jsx(Text, {
        size: "small",
        color: "secondary",
        margin: "0 x-small"
      }, stimulusLabel))), jsx(ActionButtons, {
        connectDragSource: this.props.connectDragSource,
        displayPosition: this.props.displayPosition,
        onDelete: this.props.openDeleteStimulusModal,
        quizEntries: this.props.quizEntries,
        quizEntry: this.props.quizEntry,
        scrollKey: this.props.scrollKey,
        shouldDisableDragHandle: this.props.shouldDisableDragHandle,
        switchOnEditing: this.props.switchOnEditing,
        shouldFocusOnMount: this.props.shouldFocusOnMount,
        shouldDisableCopy: this.props.isQuizContentLocked,
        shouldRenderEdit: !this.props.isQuizContentLocked,
        shouldRenderDelete: !this.props.isQuizContentLocked
      })), jsx("div", {
        role: "presentation",
        onClick: this.props.isQuizContentLocked ? null : this.switchOnEditing,
        css: this.props.styles.stimulusContent,
        "data-testid": "stimulus-content"
      }, jsx(StimulusShowInfo, {
        stimulus: this.props.stimulus
      }))));
    }
  }]);
}(Component), _defineProperty(_StimulusShow, "displayName", 'StimulusShow'), _defineProperty(_StimulusShow, "componentId", "Quizzes".concat(_StimulusShow.displayName)), _defineProperty(_StimulusShow, "propTypes", {
  connectDragSource: PropTypes.func.isRequired,
  displayPosition: PropTypes.number.isRequired,
  isBankedContent: PropTypes.bool,
  isQuizContentLocked: PropTypes.bool.isRequired,
  openDeleteStimulusModal: PropTypes.func.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  scrollKey: PropTypes.string,
  shouldDisableDragHandle: PropTypes.bool,
  stimulus: ImmutablePropTypes.record.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  shouldFocusOnMount: PropTypes.bool.isRequired,
  styles: PropTypes.object
}), _defineProperty(_StimulusShow, "defaultProps", {
  isBankedContent: false,
  isQuizContentLocked: false,
  scrollKey: '',
  shouldDisableDragHandle: false,
  shouldFocusOnMount: false
}), _StimulusShow)) || _class);
export default StimulusShow;